
import { Vue, Component, Ref, Watch } from 'vue-property-decorator';
import GeneratePurchaseOrderDrawer from './components/GeneratePurchaseOrderDrawer.vue';
import PlatPurchaseOrderDetailModal from './components/PlatPurchaseOrderDetailModal.vue';
import lazyInject from '@/di';
import SupplyService from '@/services/supply.service';
import { CPlatOrderList } from '@/models/supply.model';
import InvoiceUploadModal from './components/InvoiceUploadModal.vue';
import ConfirmPaymentRequestModal from './components/ConfirmPaymentRequestModal.vue';
import moment from 'moment';
import { AuthEnum } from '@/services/permission.service';

@Component({
  components: {
    GeneratePurchaseOrderDrawer,
    PlatPurchaseOrderDetailModal,
    InvoiceUploadModal,
    ConfirmPaymentRequestModal,
  },
})
export default class PlatformPurchaseOrder extends Vue {
  loading = false;

  AuthEnum = AuthEnum;

  @lazyInject(SupplyService)
  supplyService!: SupplyService;

  filterForm: any = {
    batch_no: '',
    po: '',
    pay_status: undefined,
    start_time: '',
    end_time: '',
    invoice_status: undefined,
    amap_invoice_status: undefined,
  };

  @Ref('invoiceUploadModal')
  invoiceUploadModal!: InvoiceUploadModal;

  @Ref('confirmPaymentRequestModal')
  confirmPaymentRequestModal!: ConfirmPaymentRequestModal;

  dataSource: any[] = [];

  payStatusOptions = [
    { label: '待请款', value: 0 },
    { label: '已付款', value: 1 },
  ];

  invoiceStatusOptions = [
    { label: '未开票', value: 0 },
    { label: '已开票', value: 1 },
  ];

  payStatusMap: any = {
    0: '待请款',
    1: '已付款',
  };

  invoiceStatusMap: any = {
    0: '未开票',
    1: '已开票',
  };

  columns = [
    {
      title: '请款批次',
      dataIndex: 'batchNo',
      align: 'center',
    },
    {
      title: '请款日期',
      dataIndex: 'createdAt',
      align: 'center',
    },
    {
      title: '归集订单数量',
      dataIndex: 'purchaseOrderNum',
      align: 'center',
    },
    {
      title: '销售总额',
      dataIndex: 'purchaseOrderAmount',
      align: 'center',
    },
    {
      title: '采购总额',
      dataIndex: 'platAmount',
      align: 'center',
    },
    {
      title: '关联PO',
      dataIndex: 'po',
      align: 'center',
    },
    {
      title: '高德付款状态',
      dataIndex: 'payStatus',
      align: 'center',
      scopedSlots: { customRender: 'payStatus' },
    },
    {
      title: '到账日期',
      dataIndex: 'poTime',
      align: 'center',
    },
    {
      title: '开票状态',
      dataIndex: 'invoiceStatus',
      align: 'center',
      scopedSlots: { customRender: 'invoiceStatus' },
    },
    {
      title: '操作',
      dataIndex: 'action',
      align: 'center',
      fixed: 'right',
      width: 260,
      scopedSlots: { customRender: 'action' },
    },
  ];

  pagination: any = {
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: this.$store.state.pageSize.pageSize,
    showTotal: () => `共${this.pagination.total}条`,
    onChange: this.paginationChange,
    onShowSizeChange: this.onShowSizeChange,
  };

  @Watch('$route')
  async handleSearch() {
    const {
      batch_no,
      po,
      pay_status,
      start_time,
      end_time,
      invoice_status,
      amap_invoice_status,
      page,
      pageSize,
    } = this.$route.query;
    const params: any = {
      page: page || 1,
      pageSize: pageSize || 10,
    };
    if (batch_no) {
      params.batch_no = batch_no;
      this.filterForm.batch_no = batch_no;
    }
    if (po) {
      params.po = po;
      this.filterForm.po = po;
    }
    if (pay_status !== undefined) {
      params.pay_status = pay_status;
      this.filterForm.pay_status = +pay_status;
    }
    if (start_time && end_time) {
      params.start_time = start_time;
      params.end_time = end_time;
      this.filterForm.start_time = start_time;
      this.filterForm.end_time = end_time;
    }
    if (invoice_status !== undefined) {
      params.invoice_status = invoice_status;
      this.filterForm.invoice_status = +invoice_status;
    }
    if (amap_invoice_status !== undefined) {
      params.amap_invoice_status = amap_invoice_status;
      this.filterForm.amap_invoice_status = +amap_invoice_status;
    }
    this.getList(params);
  }

  mounted() {
    this.handleSearch();
  }

  getQueryParams() {
    const {
      batch_no,
      po,
      pay_status,
      start_time,
      end_time,
      invoice_status,
      amap_invoice_status,
    } = this.filterForm;
    const { current, pageSize } = this.pagination;
    const query: any = { page: current, pageSize };
    if (batch_no) {
      query.batch_no = batch_no;
    }
    if (po) {
      query.po = po;
    }
    if (pay_status !== undefined) {
      query.pay_status = pay_status;
    }
    if (start_time && end_time) {
      query.start_time = start_time;
      query.end_time = end_time;
    }
    if (invoice_status !== undefined) {
      query.invoice_status = invoice_status;
    }
    if (amap_invoice_status !== undefined) {
      query.amap_invoice_status = amap_invoice_status;
    }
    query.timestamp = Math.round(Date.now() / 1000);
    this.$router.push({
      query,
    });
  }

  openInvoiceModal(record: any, type: string) {
    this.invoiceUploadModal.open(record, type);
  }

  confirmPaymentRequest(record: any) {
    this.confirmPaymentRequestModal.open(record);
  }

  async getList(params: any) {
    // TODO: 调用平台采购单列表接口，参数：this.filterForm、this.pagination.current
    const res = await this.supplyService.getPurchaseOrderList(params, this.$el);
    this.loading = false;
    this.dataSource = res.list.map((item: any) => CPlatOrderList.from(item));
    // console.log(this.dataSource);
    this.pagination.total = res.total;
    this.pagination.current = res.page;
    this.pagination.pageSize = res.pageSize;
  }

  search() {
    this.pagination.current = 1;
    this.getQueryParams();
  }

  resetQuery() {
    this.filterForm = {
      batch_no: '',
      po: '',
      pay_status: undefined,
      start_time: '',
      end_time: '',
      invoice_status: undefined,
      amap_invoice_status: undefined,
    };
    this.pagination.current = 1;
    this.getQueryParams();
  }

  formatDate(date: any) {
    return date ? moment(date).format('YYYY-MM-DD') : '';
  }

  onChangeArriveDate(dates: any) {
    this.filterForm.start_time = this.formatDate(dates && dates[0]);
    this.filterForm.end_time = this.formatDate(dates && dates[1]);
  }

  paginationChange(page: number, pageSize: number) {
    this.pagination.current = page;
    this.pagination.pageSize = pageSize;
    this.getQueryParams();
  }

  onShowSizeChange(current: number, pageSize: number) {
    this.pagination.current = 1;
    this.pagination.pageSize = pageSize;
    this.getQueryParams();
  }

  viewDetail(record: any) {
    this.platPurchaseOrderDetailModal.open(record.batchNo);
  }

  @Ref('generatePurchaseOrderDrawer')
  generatePurchaseOrderDrawer!: GeneratePurchaseOrderDrawer;

  @Ref('platPurchaseOrderDetailModal')
  platPurchaseOrderDetailModal!: PlatPurchaseOrderDetailModal;

  openGenerateDrawer() {
    this.generatePurchaseOrderDrawer.open();
  }
}
